import { api } from '../api';

// Ticket 131: TX property-tax lookup. Paths are relative to the portal axios
// instance (same as /fee-worksheet/estimate).
export const getCounties = () => api.get('/property-tax/counties').then((r) => r.data);

export const getUnits = (county) => api.get('/property-tax/units', { params: { county } }).then((r) => r.data);

export const lookup = (address) => api.post('/property-tax/lookup', { address }).then((r) => r.data);

// POST, not GET: the typed address must not land in a URL. Resolves {enabled, suggestions}.
// `state` (two letters) narrows the search to that state; empty searches the whole US.
export const suggestAddress = (q, state) => api.post('/property-tax/address-suggest', { q, state: state || null }).then((r) => r.data);
